"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextSubMenu = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_contexify_1 = require("react-contexify");
const Icon_1 = require("../../elements/Icon");
const ContextSubMenu = (_a) => {
    var { icon, label } = _a, rest = (0, tslib_1.__rest)(_a, ["icon", "label"]);
    return ((0, jsx_runtime_1.jsx)(react_contexify_1.Submenu, Object.assign({}, rest, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: "context-menu__icon" }, { children: icon && (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: icon, className: "context-menu__icon-svg" }, void 0) }), void 0), label] }, void 0) }), void 0));
};
exports.ContextSubMenu = ContextSubMenu;
//# sourceMappingURL=ContextSubMenu.js.map